// One place for every page's title and description.
// To change a page's title or description, edit it here (keep titles under 60
// characters and descriptions under 155 characters).

import { cities, cityPath, cityFullName, CITY_BASE_PATH } from "./cities";
import { posts, blogPostPath, BLOG_BASE_PATH } from "./blogPosts";

export const SITE_URL = "https://www.airloo.in";

export const seoData = {
  "/": {
    title: "Portable Toilets on Rent in Bangalore & Karnataka | AirLoo",
    description:
      "Portable & mobile toilets on rent in Bangalore and across Karnataka for weddings, functions & events. Coolers, mist fans & heaters too. Get a quote.",
  },
  "/toilets": {
    title: "Portable Toilets on Rent in Bangalore | AirLoo",
    description:
      "Hygienic portable toilets on rent in Bangalore for weddings, events and functions. Western, Indian and luxury van options. Call AirLoo for a quote.",
  },
  "/toilet-van": {
    title: "Mobile Toilet Van on Rent in Bangalore | AirLoo",
    description:
      "Luxury AC toilet vans on rent in Bangalore for weddings, corporate events and functions. Clean, comfortable mobile toilets. Call AirLoo for a quote.",
  },
  "/bluestart-toilet": {
    title: "Blue Star Western Toilet on Rent in Bangalore | AirLoo",
    description:
      "Blue Star western style portable toilet on rent in Bangalore with a 400-liter waste tank, 130-liter water tank and hand wash pump. Get a quote from AirLoo.",
  },
  "/premium-western-toilet": {
    title: "Premium Western Style Toilet on Rent in Bangalore | AirLoo",
    description:
      "Premium western style portable toilet on rent in Bangalore with a separate fresh water flush, wash basin and heat-resistant walls. Get a quote from AirLoo.",
  },
  "/indian-toilet": {
    title: "Indian Style Toilet on Rent in Bangalore | AirLoo",
    description:
      "Indian style portable toilets on rent in Bangalore for weddings, religious gatherings, melas and rural events. Lockable, with water tap. Get a quote.",
  },
  "/western-toilet-monthly-rent": {
    title: "Western Toilet on Monthly Rent in Bangalore | AirLoo",
    description:
      "Western toilets on monthly rent in Bangalore for construction sites and long-term use. Ceramic WC, washbasin, flush, strong HDPE body. Get a quote.",
  },
  "/urinals": {
    title: "Men's Portable Urinals on Rent in Bangalore | AirLoo",
    description:
      "Men's portable urinals on rent in Bangalore for weddings, birthdays and business events. Two users at once, 265-liter tank, 1000-user capacity.",
  },
  "/heater": {
    title: "Gas Heater on Rent in Bangalore | Patio & Event Heaters",
    description:
      "Patio gas heaters on rent in Bangalore for garden parties, weddings and events. 7-8 ft stainless steel tower heater, adjustable heat. Get a quote.",
  },
  "/cooling-system": {
    title: "Event Cooling Systems on Rent in Bangalore | AirLoo",
    description:
      "Cooling for weddings and outdoor events: air coolers, mist fans and tower ACs on rent in Bangalore. Keep guests comfortable. Get a quote from AirLoo.",
  },
  "/cooler": {
    title: "Air Coolers on Rent in Bangalore | AirLoo",
    description:
      "Air coolers on rent in Bangalore for weddings, birthdays and business events. 30-inch fan, covers up to 2000 sq ft, remote control. Get a quote.",
  },
  "/mistfan": {
    title: "Mist Fans on Rent in Bangalore | AirLoo",
    description:
      "Mist fans on rent in Bangalore for outdoor weddings, birthdays and cultural events. Stainless steel, 30-liter water tank, safe enclosed fan. Get a quote.",
  },
  "/ac": {
    title: "Tower AC on Rent in Bangalore | AirLoo",
    description:
      "Standing tower ACs on rent in Bangalore for indoor weddings, birthdays and business events. 7200W cooling, remote control, auto-restart. Get a quote.",
  },
  "/services": {
    title: "Portable Toilet & Event Rentals in Bangalore | AirLoo",
    description:
      "All AirLoo rental services in Bangalore: portable toilets, toilet vans, urinals, air coolers, mist fans, tower ACs and heaters. Get a quote today.",
  },
  "/gallery": {
    title: "Portable Toilet & Cooler Rental Photos, Bangalore | AirLoo",
    description:
      "See photos of AirLoo portable toilets, luxury toilet vans, urinals, air coolers, mist fans and heaters. Get a quote for your event in Bangalore or Karnataka.",
  },
  "/aboutus": {
    title: "About AirLoo | Portable Toilet Rental in Bangalore",
    description:
      "AirLoo, founded in 2025 in Bengaluru, is built on 20+ years of rental industry experience. Portable toilets, coolers, mist fans and heaters for events.",
  },
  "/portable-toilets-near-me": {
    title: "Portable & Mobile Toilets on Rent Near Me | AirLoo",
    description:
      "Looking for portable toilets near me? AirLoo delivers portable toilets, urinals, hand wash stations, coolers and heaters across Bangalore and Karnataka.",
  },
  "/contactus": {
    title: "Contact AirLoo | Portable Toilets on Rent in Bangalore",
    description:
      "Call +91 8307701090 or send an enquiry to rent portable toilets, urinals, coolers and heaters in Bangalore and Karnataka. Office in Yelahanka, Bengaluru.",
  },
};

// Used for any address that is not in the list above (a wrong or old link).
export const notFoundSeo = {
  title: "Page not found | AirLoo",
  description:
    "This page could not be found. Visit the AirLoo homepage to rent portable toilets, coolers, mist fans and heaters for your event.",
};

// The list of service areas, and every city or area page in src/cities.js,
// get their own title and description automatically.
seoData[CITY_BASE_PATH] = {
  title: "Service Areas in Bangalore & Karnataka | AirLoo",
  description:
    "AirLoo rents portable toilets, luxury toilet vans, urinals, coolers, mist fans and heaters across Bangalore and Karnataka. Find your area and get a quote.",
};

cities.forEach((city) => {
  const full = cityFullName(city);
  seoData[cityPath(city.slug)] = {
    title: `Portable Toilets on Rent in ${full} | AirLoo`,
    description: `Portable toilets, luxury toilet vans and urinals on rent in ${full}, plus air coolers, mist fans and heaters. Get a quote from AirLoo.`,
  };
});

// The blog list page, and every post in src/blogPosts.js, get their own
// title and description automatically.
seoData[BLOG_BASE_PATH] = {
  title: "Blog | AirLoo Portable Toilets & Event Rentals",
  description:
    "Answers to real questions about renting portable toilets, coolers, mist fans and heaters for your event in Bangalore and Karnataka.",
};

posts.forEach((post) => {
  seoData[blogPostPath(post.slug)] = {
    title: `${post.title} | AirLoo Blog`,
    description: post.excerpt,
  };
});

seoData["/handwash"] = {
  title: "Portable Hand Wash Station on Rent in Bangalore | AirLoo",
  description:
    "Portable hand wash stations on rent in Bangalore for weddings, food stalls and festivals. Twin-unit basins with taps. Get a quote from AirLoo.",
};

seoData["/deluxe-premium-toilet"] = {
  title: "Deluxe Premium Portable Toilet on Rent in Bangalore | AirLoo",
  description:
    "Deluxe Premium portable toilet on rent in Bangalore with a 200 L waste tank, 120 L water tank and Alfa Gun flush. For weddings, events and sites.",
};

seoData["/privacy-policy"] = {
  title: "Privacy Policy | AirLoo",
  description:
    "How AirLoo collects, uses and protects your personal data on this website, and how to contact us about it.",
};

seoData["/portable-toilet-monthly-rent"] = {
  title: "Portable Toilet on Monthly Rent in Bangalore | AirLoo",
  description:
    "Portable and mobile toilets on monthly rent in Bangalore for construction sites, factories and hostels. Indian and premium western style units. Get a quote.",
};